import React from 'react';
import { TableCell, TableRow } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
        backgroundColor: 'lightblue',
    },
});

export const MaterialItemCompras = (props) => {
    const { item } = props;
    const classes = useRowStyles();
    console.log(item)
    return (
        <>
            <TableRow className={classes.root}>
                <TableCell style={{textAlign:'center'}}>-</TableCell>
                        <TableCell>
                            {item.materiales?.descripcion}
                        </TableCell>
                        <TableCell style={{textAlign:'right'}}>{item.cantidad}</TableCell>
                        <TableCell style={{textAlign:'center'}}>-</TableCell>
                        <TableCell style={{textAlign:'center'}}>-</TableCell>
            </TableRow>
        </>
    )
}